import type {
  ConditionRouteBranch,
  ConditionRouteContext,
  ConditionRouteNode,
  OutcomeRef,
  PatientCondition,
} from "../types";
import type { PatientInput } from "../types/patient.types";

export function matchesPatientCondition(
  condition: PatientCondition,
  patient: PatientInput,
): boolean {
  if (condition.patientIsFemale !== undefined) {
    if (patient.isFemale === undefined) return false;
    if (patient.isFemale !== condition.patientIsFemale) return false;
  }

  if (condition.patientAgeAtLeast !== undefined) {
    if (patient.ageYears === undefined || patient.ageYears === null) return false;
    if (!(patient.ageYears >= condition.patientAgeAtLeast)) return false;
  }

  if (condition.patientAgeUnder !== undefined) {
    if (patient.ageYears === undefined || patient.ageYears === null) return false;
    if (!(patient.ageYears < condition.patientAgeUnder)) return false;
  }

  return true;
}

function matchesConditionRouteBranch(
  branch: ConditionRouteBranch,
  ctx: ConditionRouteContext,
): boolean {
  if ("when" in branch) {
    return matchesPatientCondition(branch.when, ctx.patient);
  }

  return branch.evaluate(ctx);
}

export function resolveConditionRoute(
  node: ConditionRouteNode,
  ctx: ConditionRouteContext,
): string | OutcomeRef {
  for (const condition of node.conditions) {
    if (matchesConditionRouteBranch(condition, ctx)) {
      return condition.then;
    }
  }

  return node.default;
}
